import { Link } from "@/lib/router-compat";
import { MapPin } from "lucide-react";
import { serviceAreaCities } from "@/data/serviceAreas";

/**
 * "Serving the North Metro" — sitewide service-area link block.
 *
 * Rendered at the bottom of /roofing, /siding, /gutters and the
 * /services/deck-installation page so every hub page distributes
 * link equity to all 13 city pages.
 */
export const ServiceAreaLinks = () => (
  <section className="py-16 bg-section-alt" aria-labelledby="service-area-links-heading">
    <div className="container mx-auto px-4">
      <div className="max-w-3xl mx-auto text-center mb-10">
        <div className="inline-flex items-center gap-2 text-secondary mb-3">
          <MapPin className="w-5 h-5" aria-hidden="true" />
          <span className="text-sm font-semibold uppercase tracking-wide">Local Coverage</span>
        </div>
        <h2
          id="service-area-links-heading"
          className="text-3xl md:text-4xl font-heading font-bold text-foreground mb-4"
        >
          Serving the North Metro
        </h2>
        <p className="text-lg text-muted-foreground">
          Cedar Creek Construction is a trusted local contractor across the
          Twin Cities north metro. Find dedicated information for your city below.
        </p>
      </div>

      <nav aria-label="Service area cities">
        <ul className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-3 max-w-5xl mx-auto">
          {serviceAreaCities.map((city) => (
            <li key={city.slug}>
              <Link
                to={`/service-areas/${city.slug}`}
                className="block bg-card border border-border rounded-lg px-4 py-3 text-center text-foreground hover:border-secondary hover:text-secondary transition-colors focus:outline-hidden focus-visible:ring-2 focus-visible:ring-secondary"
              >
                {city.name}, MN
              </Link>
            </li>
          ))}
          <li>
            <Link
              to="/service-areas"
              className="block bg-primary text-primary-foreground border border-primary rounded-lg px-4 py-3 text-center font-semibold hover:bg-primary/90 transition-colors focus:outline-hidden focus-visible:ring-2 focus-visible:ring-secondary"
            >
              View All Areas
            </Link>
          </li>
        </ul>
      </nav>
    </div>
  </section>
);
